import script from "./FiltroSliderPrecio.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltroSliderPrecio.vue?vue&type=script&setup=true&lang=js"

import "./FiltroSliderPrecio.vue?vue&type=style&index=0&id=6c17bd98&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c17bd98"]])

export default __exports__